export const REQUEST_NON_REV_AND_REV_FACILITIES_DATA = 'REQUEST_NON_REV_AND_REV_FACILITIES_DATA';
export const RECEIVE_NON_REV_AND_REV_FACILITIES_DATA = 'RECEIVE_NON_REV_AND_REV_FACILITIES_DATA';

export const ERROR_RETRIEVING_NON_REV_AND_REV_FACILITIES_DATA = 'ERROR_RETRIEVING_NON_REV_AND_REV_FACILITIES_DATA';

export const receiveNonRevAndRevFacilitiesData = (payload) => ({
    type: RECEIVE_NON_REV_AND_REV_FACILITIES_DATA,
    payload: payload
});

export const errorRetrievingNonRevAndRevFacilitiesData = error => ({type: ERROR_RETRIEVING_NON_REV_AND_REV_FACILITIES_DATA, payload: error});



// WEBPACK FOOTER //
// ./src/actions/nonRevAndRevFacilitiesActions.js